export const SENTRY_DSN = "https://549f4af5ae9abce508ef37f6bad7024a@o4509763481567232.ingest.de.sentry.io/4509770031300688"
export const SENTRY_TUNNEL = "/sentry"
